import en from "../../../i18n/languages/en.json";
import tr from "../../../i18n/languages/tr.json";
import { useEffect, useState } from "react";
import { LANGUAGE_CODES } from "../../../routes";

type TranslationsType = typeof en;
export type PageKey = keyof TranslationsType;

export const useSeo = (pageKey: PageKey) => {
  const [language, setLanguage] = useState(
    localStorage.getItem("language") ?? LANGUAGE_CODES.TR
  );

  useEffect(() => {
    const handleLangChange = () => {
      setLanguage(localStorage.getItem("language") ?? LANGUAGE_CODES.TR);
    };

    window.addEventListener("storage", handleLangChange);
    window.addEventListener("local-storage-language-change", handleLangChange);

    return () => {
      window.removeEventListener("storage", handleLangChange);
      window.removeEventListener(
        "local-storage-language-change",
        handleLangChange
      );
    };
  }, []);

  useEffect(() => {
    const translations = language === LANGUAGE_CODES.EN ? en : tr;

    const title = translations[pageKey]?.seo?.title ?? "";
    const description = translations[pageKey]?.seo?.description ?? "";
    const keywords = translations[pageKey]?.seo?.keywords ?? "";

    document.title = title;

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute("content", description);
    } else {
      const meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      meta.setAttribute("content", description);
      document.head.appendChild(meta);
    }

    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute("content", keywords);
    } else {
      const meta = document.createElement("meta");
      meta.name = "keywords";
      meta.content = keywords;
      document.head.appendChild(meta);
    }
  }, [pageKey, language]);
};

const setMeta = (name: string, content: string) => {
  let meta = document.querySelector(`meta[name='${name}']`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("name", name);
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", content);
};

export const usePageSeo = (title: string, description: string) => {
  useEffect(() => {
    document.title = title;
    setMeta("description", description);
  }, [title, description]);
};
